import React from 'react';
import { DashboardLayout } from './DashboardLayout';

/**
 * AppShell wraps a page in the standard authenticated app chrome
 * (left sidebar + top bar + mobile bottom nav) via DashboardLayout.
 *
 * Use this at the route level so pages don't have to import
 * DashboardLayout individually. Pages that need a focus/no-chrome
 * mode (auth, session runners, public share views) should not be
 * wrapped in AppShell.
 */
export const AppShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <DashboardLayout>{children}</DashboardLayout>;
};

export default AppShell;